<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            
            
            <Authentication_step1></Authentication_step1>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      import Authentication_step1 from "./Authentication_step1";
      import Authentication_pay from "./Authentication_pay";

      export default {
            name: 'main',
            components: {topbar, left, Authentication_step1, Authentication_pay},
            data() {
                  return {}
            },
            mounted() {
                  this.show();
            },
            methods: {
                  show: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication_status',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              if (response.data.code == 1) {
                                    window.location.href = '#/Authentication_show?key=' + response.data.msg;
                              } else if (response.data.code == 2) {
                                    //这里是流程正在走
                                    if (response.data.status == 1) {
                                          //window.location.href = '#/Authentication_pay?id=' + response.data.recordid;
                                        //这里本来是要跳转到付款页面，现取消收费，直接邮寄发票
                                        window.location.href = '#/Authentication_fapiao?out_trade_no=' + response.data.recordid;
                                    } else {
                                          let str = '';
                                          if (response.data.status == 0) {
                                                str = '您已成功提交首次认证申请。工作人员将在十个工作日内审核完成，请及时关注审核结果。';
                                                window.location.href = '#/Authentication_show?key=' + str;
                                          }
                                          if (response.data.status == 3) {
                                                if (response.data.province == null) {
                                                      //已经付款但是没填写发票地址
                                                      window.location.href = '#/Authentication_fapiao?out_trade_no=' + response.data.orderid;
                                                } else {
                                                      //已付款等待证书。
                                                      str = '1';
                                                      window.location.href = '#/Authentication_show?key=' + str;
                                                }
                                                //console.log(response.data.title);
                                          }
                                          if (response.data.status == 4) {
                                                //证书已经邮寄
                                                str = '2';
                                                window.location.href = '#/Authentication_show?key=' + str;
                                          }

                                    }


                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx {
            width: 100%;
      }
      
      .zx li {
            width: 100%;
            float: left
      }


</style>



// WEBPACK FOOTER //
// src/components/Authentication.vue